import React, { memo } from '../../lib/teact/teact';

import buildClassName from '../../util/buildClassName';
import { METADATA_CATEGORY_COLORS } from '../../util/walletMetadataDirectory';

import styles from './MetadataIdentity.module.scss';

export default memo(({ emoji, color, className }: { emoji: string; color: string; className?: string }) => (
  <span
    className={buildClassName(styles.categoryIcon,
      styles[`pastel${METADATA_CATEGORY_COLORS.findIndex((value) => value === color.toUpperCase())}`], className)}
    aria-hidden
    data-telemetry-block=""
  >
    {emoji}
  </span>
));
